import React from "react";
import { Button } from "@tyrannosaurustech/ui";
import { BulkButton } from "./types";

interface BulkSelectionBarProps<DataType> {
  selectedCount: number;
  bulkButtons: BulkButton<DataType>[];
  clearSelection: () => void;
  selectedRows: any[];
}

export function BulkSelectionBar<DataType>({
  selectedCount,
  bulkButtons,
  clearSelection,
  selectedRows,
}: BulkSelectionBarProps<DataType>) {
  if (selectedCount === 0) return null;

  return (
    <div className="flex py-1 px-4 gap-4 sticky z-10 bg-neutral-0 dark:bg-neutral-900 top-0 items-center justify-between border-b border-neutral-300">
      <div className="flex items-center gap-2">
        <span className="text-sm font-medium text-neutral-900 dark:text-neutral-100">
          {selectedCount} selected
        </span>
      </div>
      <div className="flex gap-2">
        {bulkButtons.map((btn, idx) => (
          <Button
            key={idx}
            onClick={() => btn.onClick(selectedRows)}
            variant={(btn.variant as any) || "primary"}
          >
            {btn.label}
          </Button>
        ))}
        <Button onClick={clearSelection} variant={"secondary" as any}>
          Clear Selection
        </Button>
      </div>
    </div>
  );
}
